import styled from "@emotion/styled";
// eslint-disable-next-line no-empty-pattern
export const TelLink = styled("a")(({}) => ({
  textDecoration: "none",
  fontSize: "0.8rem",
  fontWeight: "bold",
  color: "inherit",
  textAlign: "center",
}));
